import { LandingContent } from "./types";

export const fieldCoachLanding: LandingContent = {
  ctaText: "Book a Field Coach call",
  quickFacts: ["No rip-and-replace", "Pilot available", "Methodology-aware"],
  whyHeading: "Why teams use Field Coach",
  why: "Field Coach is an AI virtual ride-along built for sales managers who can't be in every truck. It listens to 100% of sales conversations, evaluates them against your defined standards — script adherence, objection handling, discovery quality, pacing — and surfaces the moments that matter. Methodology drift gets corrected immediately, close rates stabilize, and coaching becomes evidence-based instead of hunch-based.",
  advantages: [
    {
      title: "Continuous call analysis",
      description:
        "Every sales conversation across the team captured, transcribed, and scored — no sampling, no guessing which calls to listen to.",
      includedNote: "100% call visibility across the team",
    },
    {
      title: "Methodology evaluation",
      description:
        "Script adherence, objection handling, discovery quality, and pacing all measured against your defined standards — not a generic template.",
      includedNote: "Rep-level scoring against your methodology",
    },
    {
      title: "Pattern & trend detection",
      description:
        "Surfaces systemic issues like margin erosion from discounting, weak discovery habits, or rushed option-presentation transitions.",
      includedNote:
        "Trend detection — discounting, weak discovery, rushed transitions",
    },
  ],
  featureChecklist: [
    "100% call visibility across the team",
    "Rep-level scoring against your methodology",
    "Trend detection — discounting, weak discovery, rushed transitions",
    "Evidence-based coaching queue for managers",
  ],
  highlights: [
    {
      title: "Manager coaching queue",
      description:
        "The three specific clips each manager should review this week, ranked by downstream revenue impact — not chronology.",
    },
  ],
  steps: [
    {
      title: "Connect your phone & meeting tools",
      description:
        "Field Coach plugs into your existing phone system and video tools — no rip and replace.",
    },
    {
      title: "AI listens to every conversation",
      description:
        "Calls and ride-along audio are transcribed and scored against your defined methodology in minutes.",
    },
    {
      title: "Managers coach with the highlights",
      description:
        "Each manager gets a weekly queue of the three clips that will most move the needle for each rep.",
    },
    {
      title: "Trends inform team training",
      description:
        "Patterns across reps surface what to coach in the next team huddle — discounting, weak discovery, anything systemic.",
    },
  ],
  testimonials: [],
  faqs: [
    {
      question: "How quickly can we get started?",
      answer:
        "Most teams are scoring their first calls within a week. Phone-system integration is the longest step, and we handle it.",
    },
    {
      question: "Do reps know they're being analyzed?",
      answer:
        "Yes — and they prefer it. Field Coach is positioned as coaching infrastructure, not surveillance. Most teams roll it out with a kickoff so reps know what's being measured.",
    },
    {
      question: "How is this different from generic call recording?",
      answer:
        "Field Coach scores against your specific methodology, not a generic QA template. It surfaces the three clips that matter — not 200 hours of audio.",
    },
    {
      question: "Will it work with my CRM and phone system?",
      answer:
        "Yes. Field Coach integrates with major phone systems and writes scores back to most CRMs. We confirm fit on the discovery call.",
    },
  ],
  closing: {
    heading: "Stop guessing what's happening on calls",
    body: "Get a free Field Coach assessment showing exactly where coaching gaps are costing you revenue.",
  },
};
